import styles from './index.css';

import * as React from 'react';
import classNames from 'classnames';

type CheckIndicatorProps = {
	isChecked: boolean;
	isInvalid?: boolean;
	required?: boolean;
	look?: 'square'|'circle'|'hook',
	className?: string;
}
export default ({isChecked, isInvalid = false, required, look = 'square', className = ''}: CheckIndicatorProps) => (
	<div className={(classNames(
		styles.checkIndicator,
		isChecked && styles.isChecked,
		isInvalid && styles.isInvalid,
		look === 'circle' && styles.isCircle,
		!isChecked && required && styles.isRequired,
		className
	))}>
		<span></span>
	</div>
)
